import { render, staticRenderFns } from "./settingView.vue?vue&type=template&id=3f74b9eb&scoped=true&lang=html&"
import script from "./settingView.vue?vue&type=script&lang=js&"
export * from "./settingView.vue?vue&type=script&lang=js&"
import style0 from "./settingView.vue?vue&type=style&index=0&id=3f74b9eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74b9eb",
  null
  
)

export default component.exports